import React, { useState } from 'react';
import DownloadIcon from 'assets/svgs/downloadArrow.svg';
import {
  AlertNotice,
  ModalInfo,
  Radio
} from 'shared/components';
import RostersService from '../RostersService';

import { useTranslation } from 'react-i18next';
const AuthorizationTicketsModal = ({  authorizationModalOpen, toggleAuthorizationModal, id }) => {
  const { t } = useTranslation();


  const [selected, setSelected] = useState('list');
  const [errorMessage, setErrorMesage] = useState('');

  const handleOptionChange = (e) => {
    setSelected(e.target.value);
  };

  const onClickDownload = async (status) => {

    const data = {
      layout: status,
      testCenterEventId: id,
    };

    setErrorMesage('')
    const response = await RostersService.getAuthorizationTickets(data);
    if (response.status === 500) {
      setErrorMesage('errors.somethingWentWrong')
    }

    if (response.url) {
      const link = document.createElement('a');
      link.href = response.url;
      link.id = 'pdf';
      link.download = '';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toggleAuthorizationModal();
    }
  };

  return (
    <ModalInfo
      modalIsOpen={authorizationModalOpen}
      closeModal={toggleAuthorizationModal}
      headerTitle={t('onlineTesting.authorizationTickets.rostersAuthorizationTitle')}
      onSubmit={()=> onClickDownload(selected)}
      saveLabel={t('onlineTesting.authorizationTickets.downloadLabel')}
      iconActionButton={<DownloadIcon />}
      containerClass="authorization-tickets-modal"
    >
      <div className="authorization-tickets-modal-content">
        {errorMessage &&
        <AlertNotice message={t(errorMessage)} type="error"/>
        }
        <AlertNotice message={t('onlineTesting.authorizationTickets.alert')} />
        <h6>{t('common.labels.selectOption')}</h6>
        <div>
          <div className="radio">
            <Radio
              value="list"
              label="List"
              checked={selected === 'list'}
              onChange={handleOptionChange}
            />
          </div>
          <div className="radio">
            <Radio
              value="page"
              label="1 per page"
              checked={selected === 'page'}
              onChange={handleOptionChange}
            />
          </div>
        </div>
      </div>
    </ModalInfo>
  );
};

export default AuthorizationTicketsModal;
